module.exports = __webpack_public_path__ + "img/drift.d8a38f53.png";